import { Table } from "antd";
import Manage from "..";
import { useEffect, useState } from "react";
import DeleteBoooking from "./components/DeleteBoooking";
import CreateBooking from "./components/CreateBooking";
import ConfirmBooking from "./components/ConfirmBooking";
import fetchAllQuotations from "../../../services/fetchAllQuotations";
import Moment from "react-moment";
import QuotationPannel from "./components/QuotationPanel";
import Toastify from "toastify-js";
import { pusher } from "../../..";

export default function AllQuotations() {
  const [createModal, setCreateModal] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [quotations, setQuotations] = useState([]);

  const handleFetchQuotations = async () => {
    const data = await fetchAllQuotations();
    setQuotations(data);
  };

  useEffect(() => {
    handleFetchQuotations();

    const quote = pusher.subscribe(`quotation`);
    quote.bind("sent", function (data: any) {
      Toastify({
        text: `New Quotation Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
      handleFetchQuotations();
    });
    return () => {
      pusher.unsubscribe("quotation");
    };
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 60,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 130,
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <span className="text-gray-700 bg-red-200 py-2">
              <span className="mr-2"> Guest:</span>

              {record?.customer_name === null ? "-" : record?.customer_name}
            </span>
          ) : (
            <span>
              {record?.customer_name === null ? "-" : record?.customer_name}
            </span>
          )}
        </div>
      ),
    },
    {
      title: "Created",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },

    {
      title: "Mobile",
      width: 100,
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <span className="text-gray-700 bg-red-200 py-2">
              <span className="mr-2"> Guest:</span>

              {record?.customer_mobile === null ? "-" : record?.customer_mobile}
            </span>
          ) : (
            <span>
              {record?.customer_mobile === null ? "-" : record?.customer_mobile}
            </span>
          )}
        </div>
      ),
    },

    {
      title: "Vehicle model",
      width: 130,
      render: (record: any) => (
        <div className="w-full">
          <span className="text-gray-700">
            {record?.vehicle_model === null ? "-" : record?.vehicle_model}
          </span>
        </div>
      ),
    },

    {
      title: "Vehicle Type",
      width: 130,
      render: (record: any) => (
        <div className="w-full">
          <span className="text-gray-700">
            {record?.vehicle_type === null ? "-" : record?.vehicle_type}
          </span>
        </div>
      ),
    },

    {
      title: "Mileage",
      width: 100,
      render: (record: any) => (
        <div className="w-full">
          <span className="text-gray-700">
            {record?.vehicle_mileage === null ? "-" : record?.vehicle_mileage}
          </span>
        </div>
      ),
    },

    {
      title: "Date",
      width: 150,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.createdAt}</Moment>
              <span className="mx-2"></span>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Status",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.status === null ? "-" : record?.status}
        </span>
      ),
    },

    {
      title: "Document",
      width: 80,
      render: (record: any) => (
        <>
          <button
            onClick={() => {
              setShowPanel(true);
              setSelected({ ...record });
            }}
            className="border py-1 px-2 text-center  bg-blue-100 hover:bg-blue-200 cursor-pointer"
          >
            Document
          </button>
        </>
      ),
    },
  ];

  return (
    <Manage
      title={"Quotations"}
      subtitle={"All"}
      description={"List of recent quotations"}
      actions={<></>}
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            columns={columns}
            dataSource={quotations}
            size="small"
            pagination={{ pageSize: 20 }}
            scroll={{ y: 425 }}
            rowKey="id"
          />

          <CreateBooking
            isVisible={createModal}
            setCreateModal={setCreateModal}
          />

          <ConfirmBooking
            selected={selected}
            isVisible={confirmModal}
            setConfirmModal={setConfirmModal}
            handleFetchBookings={handleFetchQuotations}
          />

          <DeleteBoooking
            selected={selected}
            isVisible={deleteModal}
            setDeleteModal={setDeleteModal}
          />

          <QuotationPannel
            isVisible={showPanel}
            setVisible={setShowPanel}
            selected={selected}
          />
        </div>
      </div>
    </Manage>
  );
}
